export enum newResourceConfigurationField {
  resourceType = 'resourceType',
  connectors = 'connectors',
  resourceStatus = 'resourceStatus',
  securityRisk = 'securityRisk',
  businessCriticality = 'businessCriticality',
  generativeAiOptions = 'generativeAiOptions',
  createdBy = 'createdBy',
  lastModifiedBy = 'lastModifiedBy',
  createdAt = 'createdAt',
  firstSeenAt = 'firstSeenAt',
}
